export enum EnumArticleType {
  CONSUMABLE = 'CONSUMABLE',
  DEVICE = 'DEVICE',
  TEXTILE = 'TEXTILE'
}
